import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

import { Fire, Tools } from '../../services'

import Switch from 'react-switch'
import { Headerbar, FormInput, DataTable, OnOff, ConfirmButton, Loader, EditContainer, ConfirmLink, ImagesPicker, Select } from '../Reusable'

import FadeIn from 'react-fade-in';
import TicketingPromoGrid from './TicketingPromoGrid'

const { useHistory } = require('react-router-dom')

interface Props {
  match: any;
}
const TicketingPromoScreen: React.FC<Props> = (props) => {

  const [error, setError] = React.useState('')
  const history = useHistory()
  const elementId = props.match.params.elementId
  const elementRef = Fire.collection('ads').doc(elementId)
  
  const onFetch = async (id: string) => {
    try {
      const ref = elementRef.collection('promos').doc(id)
      const element = await Fire.doc(ref)
      return element
    } catch (err) {
      setError("Impossible de charger le code promo")
      console.warn(err)
    }
    return null
  }

  const onSave = async (item: any, pictures: any[]) => {
    if (!item.code || item.code === '') {
      alert('Il faut saisir un code')
      return;
    }
    const data = {
      ...item,
      max: Number(item.max || 0),
    }

    try {
      if (item.id) {
        await elementRef.collection('promos').doc(item.id).update(data)
      }
      else {
        const newItem = elementRef.collection('promos').doc(data.code)
        data.createdAt = new Date()
        data.count = 0
        await newItem.set(data)
      }

      history.goBack()

    } catch (err) {
      setError("Impossible de modifier le code promo")
      console.warn(err)
    }
  }

  const onRemove = async (item: any) => {
    try {
      await elementRef.collection('promos').doc(item.id).delete()
      history.goBack()
    } catch (err) {
      setError("Impossible de supprimer le code promo")
      console.warn(err)
    }
  }

  const renderContent = ({item, onChange, save, saving, remove, changed, setChanged}) => {
    
    return (
      <React.Fragment>

        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Informations</h3>
          </div>
          <div className="card-body">
            <div className="item-add-form">
              <OnOff
                label="Activer"
                checked={item.active || false}
                onChange={(checked: boolean) => onChange('active', checked)}
                />
         
              <FormInput
                type="text"
                placeholder="Nom à afficher"
                value={item.name}
                onChange={(evt: any) => onChange('name', evt.target.value)}
              />

              <FormInput
                type="text"
                placeholder="Code"
                value={item.code}
                onChange={(evt: any) => onChange('code', evt.target.value.toUpperCase())}
              />

              <FormInput
                type="number"
                placeholder="Nb. code promos en vente"
                value={item.max}
                onChange={(evt: any) => onChange('max', evt.target.value)}
                />

              <FormInput
                type="number"
                placeholder="Nb. code promos déjà vendu"
                value={item.count}
                disabled={true}
                onChange={(evt: any) => onChange('count', evt.target.value)}
                />

            </div>

            <div className="centered">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={save}
                disabled={saving || !changed}
                >
                { saving ? 'Chargement...' : 'Enregistrer' }
              </button>
            </div>
          </div>
        </div>

        <TicketingPromoGrid
          elementId={elementId}
          promo={item}
          onChange={(tickets) => onChange('tickets', tickets)}

          changed={changed}
          saving={saving}
          onSave={save}
          />

        { item.id !== undefined &&
          <div className="centered">
            <ConfirmLink
              title='Supprimer'
              className='btn-remove'
              confirmTitle='Êtes-vous sûr de vouloir supprimer ce code promo ?'
              onPress={remove}
              />
          </div>
        }
      </React.Fragment>
    )
  }

  return (
    <EditContainer
      id={props.match.params.promoId}
      error={error}
      defaultCreationValue={{tickets: []}}

      onFetch={onFetch}
      onSave={onSave}
      onRemove={onRemove}
      renderContent={renderContent}
      />
  );
}

export default withRouter(TicketingPromoScreen)
